/* Somnair advertorial — scroll reveal + FAQ "one open at a time". Safe to load multiple times. */
(function () {
  if (window.__advAdvertorial) return;
  window.__advAdvertorial = true;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.adv-anim:not(.is-in)');
    var design = window.Shopify && window.Shopify.designMode;
    if (design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(document); });
  else reveal(document);

  // Theme editor: re-run when a section is added / re-rendered.
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  // FAQ: close siblings when "one open at a time" is enabled.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('.adv-faq__item') || !d.open) return;
    var list = d.closest('.adv-faq__list');
    if (!list || list.getAttribute('data-single') !== 'true') return;
    list.querySelectorAll('.adv-faq__item[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);
})();
